"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
// tslint:disable-next-line:max-line-length
// export interface IControlPropsAndContext extends IBaseControlProps, IControlWithFieldContext<formField>, IControlFormContext, IControlParentNameContext {}
/* export type IReactComponent<P = any> =
    | React.StatelessComponent<P>
    | React.ComponentClass<P>
    | React.ClassicComponentClass<P>; */
// tslint:disable-next-line
function withField(WrappedComponent, fieldCreationFunction) {
    // tslint:disable-next-line:max-line-length
    return /** @class */ (function (_super) {
        __extends(ControlWithField, _super);
        // tslint:disable-next-line:max-line-length
        function ControlWithField(props) {
            var _this = _super.call(this, props) || this;
            var form = props.form, parentName = props.parentName, name = props.name;
            var fieldName = constructName(parentName, name);
            _this.field = form.registerField(fieldName, function () { return fieldCreationFunction(fieldName, props); });
            return _this;
        }
        ControlWithField.prototype.render = function () {
            return React.createElement(WrappedComponent, __assign({ field: this.field }, this.props));
        };
        return ControlWithField;
    }(React.Component));
}
exports.withField = withField;
function constructName(parentName, name) {
    if (typeof name === 'number') {
        if (!parentName) {
            throw new Error('Field with numeric name can not be a root field.');
        }
        return parentName + "[" + name + "]";
    }
    else {
        return parentName ? parentName + "." + name : name;
    }
}
exports.constructName = constructName;
//# sourceMappingURL=WithFieldHoc.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/ui/WithFieldHoc.js
// module id = 21
// module chunks = 0